export const LEGACY_DEFAULT_HIDDEN_COLUMN_IDS: string[] = [
  "sourcePatientId",
  "patientName",
  "dob",
  "address",
  "primaryInsurance",
  "insuranceId",
  "provider",
];

export const LEGACY_MONTH_FILTER_OPTIONS = [
  {
    label: "Month",
    key: "month",
    type: "monthYear" as const,
    placeholder: "MM-YYYY",
  },
];

/** Default legacy month filter: empty so all data loads until user picks a month. */
export function getLegacyMonthFilters() {
  return { month: "" };
}

function formatYmd(date: Date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate(),
  ).padStart(2, "0")}`;
}

/** Convert MM-YYYY filter value to inclusive startDate/endDate for legacy list APIs. */
export function monthYearToDateRange(monthYear: string) {
  const [monthStr, yearStr] = String(monthYear || "").split("-");
  const month = Number(monthStr);
  const year = Number(yearStr);

  if (!month || !year) {
    return { startDate: "", endDate: "" };
  }

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startDate = new Date(year, month - 1, 1);
  const endOfMonth = new Date(year, month, 0);
  const endDate = endOfMonth > today ? today : endOfMonth;

  return {
    startDate: formatYmd(startDate),
    endDate: formatYmd(endDate),
  };
}

/** Only include startDate/endDate in API params when a month is selected. */
export function getLegacyDateRangeParams(monthYear: string) {
  const trimmed = String(monthYear || "").trim();
  if (!trimmed) return {};

  const { startDate, endDate } = monthYearToDateRange(trimmed);
  if (!startDate || !endDate) return {};

  return { startDate, endDate };
}

/** Only include month in API params when selected (Reading Count API). */
export function getLegacyMonthParam(monthYear: string) {
  const trimmed = String(monthYear || "").trim();
  if (!trimmed) return {};
  return { month: trimmed };
}
